<template>
  <div>
    <transition name="fade">
      <div class="hospital-showdv" v-if="popupShow">
        <div v-show="searchShow" class="aniOpacitydv">
          <van-search
            class="searchipt"
            v-model="searchValue"
            shape="round"
            background="#fff"
            placeholder="请输入医院名称"
            show-action
            @cancel="cancel(false)"
            @input="searchChange"
          />
          <div class="search-list">
            <van-cell
              :title="noneTxt"
              style="border: none"
              v-if="list.length == 0"
            />
            <van-list v-else>
              <van-cell
                v-for="(item, ind) in list"
                :class="{ active: active == ind }"
                :key="item.id"
                :title="item.name"
                @click="checkhospitalFn({ val: item, ind: ind })"
              />
            </van-list>
          </div>
          <Button
            class="customer customer-search"
            color="#F84025"
            @click="writeFn"
            >搜索不到？点此手动填写相关信息</Button
          >
        </div>
        <div v-show="writeShow" class="aniOpacitydv">
          <div>
            <div class="write">
              <p class="write-size"></p>
              <p class="write-size write-back" @click="writeBack">
                <span class="write-txt">返回</span>
                <span class="icon-go"></span>
              </p>
            </div>

            <div class="write write-br" @click="checkCity">
              <p class="write-size">所在城市</p>
              <p class="write-size">
                <span class="write-txt write-none" v-if="addressVal">{{
                  addressVal
                }}</span>
                <span class="write-txt write-none" v-else>请选择</span>
                <span class="icon-go"></span>
              </p>
            </div>
            <div class="write">
              <p class="write-size">医院全称</p>
              <p class="write-size write-name">
                <van-field
                  placeholder="请输入医院全称"
                  v-model="writeName"
                  input-align="right"
                />
                <span class="icon-go"></span>
              </p>
            </div>
            <div class="write">
              <van-field
                v-model="addressDetail"
                rows="2"
                autosize
                class="writarea"
                type="textarea"
                maxlength="100"
                placeholder="请输入医院的详细地址"
                show-word-limit
              />
            </div>
          </div>
          <div class="customer-dv">
            <Button
              class="customer customer-write"
              color="#F84025"
              @click="saveWrite"
              >提交</Button
            >
          </div>
          <CityCascader
            v-model="showCity"
            @changeCity="getCity"
            @cancel="showCity = false"
            tit="选择省市区"
          />
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import {
  List as VanList,
  Cell as VanCell,
  Search as VanSearch,
  Field as VanField,
  Button,
  Toast
} from "vant";
import { listHospital, saveHospital } from "@/api/mine/personalInfo";
import CityCascader from "@/components/CityCascader/CityCascader";
import { dataBurialPoint } from "@/utils/common.js";
export default {
  name: "dataPicker",
  props: {
    minDate: {
      type: Number,
      default: 1970
    }
  },
  data: function() {
    return {
      searchValue: "",
      list: [],
      popupShow: false,
      writeShow: false,
      searchShow: true,
      again: false, // 搜索开关
      active: -1,
      writeName: "",
      addressDetail: "",
      addressVal: "",
      showCity: false,
      myCityAndArr: [],
      writeAddress: [],
      noneTxt: ""
    };
  },
  // 暂无结果
  computed: {},
  components: {
    VanList,
    VanCell,
    VanSearch,
    Button,
    VanField,
    CityCascader
  },
  methods: {
    setCity() {
      let val = this.myCityAndArr;
      let nameList = val.map((v, i) => {
        if (i === 0) {
          this.writeAddress.provinceCode = v.code; //省编码
          this.writeAddress.provinceName = v.name; //省名称
          return v.name;
        } else if (i === 1) {
          this.writeAddress.cityCode = v.code; //市编码
          this.writeAddress.cityName = v.name; //市名称
          return v.name;
        } else if (i === 2) {
          this.writeAddress.areaCode = v.code; //区编码
          this.writeAddress.areaName = v.name; //区名称
          return v.name;
        }
      });
      this.addressVal = nameList.join("/");
    },
    getCity(val) {
      this.myCityAndArr = val;
      this.setCity();
      this.showCity = false;
    },
    checkCity() {
      this.showCity = true;
    },
    // 点击选择医院按钮
    init() {
      this.popupShow = true;
      if (this.searchValue == "") {
        this.list = [];
        this.loading = false;
      }
      dataBurialPoint("C011", "C011-001");
    },
    // 校验搜索关键字变化没
    searchChange() {
      this.again = false;
      this.onSearch();
    },
    // 回车键触发
    onSearch() {
      if (this.again) {
        return;
      }
      if (!this.searchValue) {
        this.noneTxt = "";
        return;
      }
      this.again = true;
      listHospital({ name: this.searchValue, pageSize: 100, pageNum: 1 })
        .then(r => {
          this.list = r.list;
          this.noneTxt = "暂无结果";
        })
        .catch(() => {});
    },
    // 选中某个医院 关闭弹窗
    checkhospitalFn({ val: val, ind: ind }) {
      this.active = ind;
      this.cancel();
      setTimeout(() => {
        this.$emit("setHospitalSuccess", {
          hospitalName: val.name,
          hospitalCode: val.code
        });
      }, 500);
      dataBurialPoint("C011", "C011-002");
    },
    cancel() {
      this.popupShow = false;
      this.writeShow = false;
      this.searchShow = true;
      this.myCityAndArr = [];
      this.writeAddress = [];
      this.writeName = "";
      this.addressDetail = "";
      this.addressVal = "";
      this.list.length = 0;
      this.searchValue = "";
      this.finished = false;
      this.active = -1;
    },
    writeFn() {
      this.writeShow = true;
      this.searchShow = false;
      dataBurialPoint("C012", "C012-001");
    },
    writeBack() {
      this.writeShow = false;
      this.searchShow = true;
    },
    saveWrite() {
      dataBurialPoint("C012", "C012-002");
      if (!this.addressVal) {
        Toast("请选择所在城市");
        return;
      }
      if (!this.writeName) {
        Toast("请输入医院全称");
        return;
      }
      let axiosData = Object.assign(
        {
          address: this.addressDetail,
          name: this.writeName
        },
        this.writeAddress
      );
      saveHospital(axiosData)
        .then(r => {
          this.cancel();
          setTimeout(() => {
            this.$emit("setHospitalSuccess", {
              hospitalName: r.name,
              hospitalCode: r.code
            });
          }, 500);
        })
        .catch(() => {});
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
